module.exports = __webpack_public_path__ + "static/banner-tv-zirconias-caixarias-5a61c13d2564845e7799484c2969fc3a.jpg";